import React, { useState } from 'react';
import { auth } from './firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

export default function LoginView() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error(err);
      setError("Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-transparent-theme">
      <div className="card bg-card border-theme shadow-lg p-4" style={{maxWidth: '400px', width: '100%'}}>
        <div className="text-center mb-4">
          <h2 className="fw-bold text-main">Nettic<span className="text-accent">.</span></h2>
          <p className="text-muted-theme small">Internal Dashboard Login</p>
        </div>
        
        {error && (
            <div className="alert alert-danger py-2 small d-flex align-items-center">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                {error}
            </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label small text-muted-theme">Email</label>
            <input 
              type="email" 
              className="form-control" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
            />
          </div>
          <div className="mb-4">
            <label className="form-label small text-muted-theme">Password</label>
            <input 
              type="password" 
              className="form-control" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
            />
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? 'Signing In...' : 'Login'}
          </button>
        </form>
        <div className="mt-3 text-center">
            <small className="text-muted-theme">Don't have an account? Contact your Super Admin.</small>
        </div>
      </div>
    </div>
  );
}